var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.6667H2.5C2.22667 14.6667 2 14.44 2 14.1667C2 13.8933 2.22667 13.6667 2.5 13.6667H14.5C14.7733 13.6667 15 13.8933 15 14.1667C15 14.44 14.7733 14.6667 14.5 14.6667Z",
    fill: "#828EE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.18 2.32C11.8867 1.02667 10.62 0.993336 9.29334 2.32L8.48668 3.12667C8.42001 3.19334 8.39334 3.3 8.42001 3.39334C8.92668 5.16 10.34 6.57334 12.1067 7.08C12.1333 7.08667 12.16 7.09334 12.1867 7.09334C12.26 7.09334 12.3267 7.06667 12.38 7.01334L13.18 6.20667C13.84 5.55334 14.16 4.92 14.16 4.28C14.1667 3.62 13.8467 2.98 13.18 2.32Z",
    fill: "#828EE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9067 7.68667C10.7133 7.59334 10.5267 7.50001 10.3467 7.39334C10.2 7.30667 10.06 7.21334 9.92001 7.11334C9.80668 7.04001 9.67334 6.93334 9.54667 6.82667C9.53334 6.82001 9.48667 6.78001 9.43334 6.72667C9.21334 6.54001 8.96668 6.30001 8.74668 6.03334C8.72668 6.02001 8.69334 5.97334 8.64668 5.91334C8.58001 5.83334 8.46668 5.70001 8.36668 5.54667C8.28668 5.44667 8.19334 5.30001 8.10668 5.15334C8.00001 4.97334 7.90668 4.79334 7.81334 4.60667C7.69097 4.34445 7.3468 4.26655 7.14218 4.47117L3.39334 8.22001C3.30668 8.30667 3.22668 8.47334 3.20668 8.58667L2.84668 11.14C2.78001 11.5933 2.90668 12.02 3.18668 12.3067C3.42668 12.54 3.76001 12.6667 4.12001 12.6667C4.20001 12.6667 4.28001 12.66 4.36001 12.6467L6.92001 12.2867C7.04001 12.2667 7.20668 12.1867 7.28668 12.1L11.0417 8.34498C11.2422 8.14445 11.1669 7.79943 10.9067 7.68667Z",
    fill: "#828EE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIedit);
export default __webpack_public_path__ + "static/media/iedit.731623c63e03c36e451163a15fdc1bcc.svg";
export { ForwardRef as ReactComponent };